export const GET_LOCALE = (locale: string) => `GET_SUPPORTED_LOCALES-${locale}`
export const GET_SUPPORTED_LOCALES = 'GET_SUPPORTED_LOCALES'
export const GET_COUNTRY = 'GET_COUNTRY'
